import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Box } from '../utility/layout.mjs';
import { useEmptyContext } from './context.mjs';
import { subtext } from './empty.vanilla.mjs';

const Title = forwardRef(
  ({ children, className, ...props }, forwardedRef) => {
    const { size } = useEmptyContext("Empty.Subtext");
    return /* @__PURE__ */ jsx(
      SubtextStyleImpl,
      {
        className: classNames(subtext({ size }), className),
        ...props,
        ref: forwardedRef,
        children
      }
    );
  }
);
const SubtextStyleImpl = styled(Box);

export { Title as default };
//# sourceMappingURL=Subtext.mjs.map
